import { useState } from 'react';
import { api } from '../services/axiosConfig';

const nomeDoArquivo = (headers, nomeRegra, data) => {
    const match = /filename="?([^";]+)"?/.exec(headers?.['content-disposition'] || '');
    if (match) return match[1];
    const slug = nomeRegra.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return `relatorio-aposentadoria-${slug}-${data}.pdf`;
};

// Com responseType blob, o corpo de erro também chega como Blob.
const mensagemDeErro = async (err) => {
    const data = err.response?.data;
    if (data instanceof Blob) {
        try {
            const corpo = JSON.parse(await data.text());
            return corpo.message || corpo.error || 'Erro ao gerar o relatório.';
        } catch {
            return 'Erro ao gerar o relatório.';
        }
    }
    return err.message || 'Erro ao gerar o relatório.';
};

const RelatorioButton = ({ filiadoId, nomeRegra, dibISO, sexo, tipoProjecao, valorCustom }) => {
    const [gerando, setGerando] = useState(false);
    const [erro, setErro] = useState(null);

    const baixar = async () => {
        setGerando(true);
        setErro(null);
        try {
            const response = await api.post(`/api/aposentadoria/relatorio/${filiadoId}`, {
                nomeRegra,
                tipoProjecao: tipoProjecao || null,
                valorCustom: tipoProjecao === 'VALOR_PERSONALIZADO' ? valorCustom : null,
                sexoOverride: sexo,
                dibOriginal: dibISO
            }, { responseType: 'blob', headers: { Accept: 'application/pdf, application/json' } });
            const url = URL.createObjectURL(response.data);
            const link = Object.assign(document.createElement('a'), {
                href: url,
                download: nomeDoArquivo(response.headers, nomeRegra, dibISO)
            });
            document.body.append(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 0);
        } catch (err) {
            setErro(await mensagemDeErro(err));
        } finally {
            setGerando(false);
        }
    };

    return (
        <div className="text-end mt-2">
            <button className="btn btn-outline-primary btn-sm" onClick={baixar} disabled={gerando}>
                {gerando
                    ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Gerando relatório...</>
                    : 'Baixar relatório (PDF)'}
            </button>
            {erro && <div className="alert alert-warning mt-2 p-2 mb-0 text-start"><small>{erro}</small></div>}
        </div>
    );
};

export default RelatorioButton;
